import { Box, Text, Button, Flex, Table } from "@chakra-ui/react";

const InfoCard = ({
  title,
  value,
  description,
  buttonText,
  bgColor,
  onClick,
}) => {
  return (
    <Box
      bg={bgColor}
      p={8}
      pb={5}
      borderRadius="2xl"
      boxShadow="md"
      textAlign="left"
      w="100%"
    >
      <Flex flex={1} direction={"column"} gap={5}>
        <Flex flex={1} direction={"row"} justifyContent={"space-between"}>
          <Text
            fontFamily={"PlusJakartaSansRegular"}
            fontWeight={400}
            fontSize={"20px"}
            lineHeight={"100%"}
            color={"#0A011B"}
          >
            {title}
          </Text>
          <Text
            fontFamily={"PlusJakartaSansRegular"}
            fontWeight={700}
            fontSize={"20px"}
            lineHeight={"100%"}
            color={"#0A011B"}
          >
            {value}
          </Text>
        </Flex>
        <Text
          fontFamily={"PlusJakartaSansRegular"}
          fontWeight={400}
          fontSize={"14px"}
          lineHeight={"24px"}
          color="#000000"
        >
          {description}
        </Text>

        <Button
          fontFamily={"PlusJakartaSansMedium"}
          fontWeight={500}
          fontSize={"14px"}
          colorScheme={"#fffff"}
          backgroundColor={"#456EFF"}
          size="sm"
          paddingX={"8"}
          paddingY={"5"}
          width={"100px"}
          mt={2}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </Flex>
    </Box>
  );
};

export default InfoCard;
